import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TextInput from "../../common/textfield/TextInput.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../common/Button/index.js";
import { failed, success } from "../../common/Toastify.jsx";
import Select from "react-select";
import { useSelector } from "react-redux";
import { FormikObj, fileTypes, deliveryTypes, protocols } from "./Constant.js";
import { useFormik } from "formik";
import InputFile from "../../common/textfield/InputFile.js";
import { handleFileUpload } from "../../../utils/ImageToBase64.js";
import { getPractitionerAuthorizedList } from "../../api/Individual/index.js";
import { decryptData } from "../../EncryptDecrypt.js";
import { getLocationQuery, getOrgnizationForLocation } from "../../api/ClinicLocation/index.js";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery.js";
import Modal from "react-bootstrap/Modal";
import "./Style.css";

function ViewReportDelivery({modalShow, handleShow, data, organizations}) {
    const navigate = useNavigate();
    const user = useSelector((state) => state?.auth?.user);
    const userRoles = user?.["cognito:groups"];
    const [btnLoading, setBtnLoading] = useState(false);
    const [orgId, setOrgId] = useState(user["custom:orgId"]);
    const readOnly = true;
    const [isFAX, setIsFAX] = useState(false);


  const formik = useFormik( {
    ...FormikObj
  })

  useEffect(() => {
    if (data.type === "FAX") {
      setIsFAX(true);
    }
  }, [data]);

  return     (
  <Modal
      backdropClassName
      backdrop={"static"}
      show={modalShow}
      onHide={handleShow}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Report Delivery Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ wordWrap: "break-word", overflowWrap: "break-word" }}>
      { organizations.length > 1 &&
            <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
              <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  Organization<span style={{ color: "red" }}> *</span>{" "}
                </label>
              </Col>
              <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectLabel">{organizations.find(org => org.value === data?.orgId)?.label || " - "}</label>
              </Col>
            </Row>
        }
        <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  Delivery Name<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{data.name || " - "}</label>
            </Col>
        </Row>
        <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  Delivery Type<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{data.type || " - "}</label>
            </Col>
        </Row>
        {!isFAX && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  Protocol<span style={{ color: "red" }}> </span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{data.protocol || " - "}</label>
            </Col>
        </Row>}
        {!isFAX && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
            <label className="searchSelectLabel">
              Host Name<span style={{ color: "red" }}> </span>{" "}
            </label>
          </Col>          
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
            <label className="searchSelectedLabel">{data.hostName || " - "}</label>
          </Col>
        </Row>}
        {!isFAX && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
            <label className="searchSelectLabel">
              Username<span style={{ color: "red" }}> </span>{" "}
            </label>
          </Col>      
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
          <label className="searchSelectedLabel">{data.userName || " - "}</label>
          </Col>
        </Row>}
        {!isFAX && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
            <label className="searchSelectLabel">
              Secret<span style={{ color: "red" }}> </span>{" "}
            </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
            <label className="searchSelectedLabel">{data.secret?.substring(0,8).replaceAll(/./g, '*') || " - "}</label>
          </Col>
        </Row>}
        <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
            <label className="searchSelectLabel">
              Target<span style={{ color: "red" }}> *</span>{" "}
            </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
            <label className="searchSelectedLabel">{data.target}</label>
          </Col>
        </Row>
        <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  File Type<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
            <label className="searchSelectedLabel">{data.fileType}</label>
          </Col>
        </Row>
        <Row>
          <Col>
          <Button style={{marginRight: "20px"}}
              onClick={() => {
                  handleShow();
              }}
              variant="secondary"
              title="Close">Close</Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default ViewReportDelivery;